exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".CardHeader__header--32IBm {\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  font-size: 14px;\n  min-height: 32px;\n  line-height: 32px;\n  background-color: #1e1f21;\n  padding: 0 15px;\n}\n.CardHeader__header--32IBm > div,\n.CardHeader__header--32IBm > span {\n  color: #f9f9f9;\n  opacity: 0.65;\n  font-weight: 400;\n}\n\n.CardHeader__disableFlex--2_2lu {\n  display: block;\n}", ""]);

// exports
exports.locals = {
	"header": "CardHeader__header--32IBm",
	"disableFlex": "CardHeader__disableFlex--2_2lu"
}; 
var style = module.exports.toString();module.exports = exports.locals || { stylesheet: "" };if (!module.exports.stylesheet) { module.exports.stylesheet = style; };